<template>
  <el-tree
    ref="tree"
    class="sky-hc-classfiy-tree__tree"
    :data="data"
    node-key="id"
    default-expand-all
    highlight-current
    :expand-on-click-node="false"
  >
    <div class="sky-hc-classfiy-tree__node" slot-scope="{ data }" @click="handleTreeClick(data)">
      <div class="sky-hc-classfiy-tree__node-label">{{ data.name }}</div>
      <el-dropdown class="sky-hc-classfiy-tree__node-handler" v-if="filterAtions(data).length" trigger="click">
        <span class="el-dropdown-link">
          <i class="el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(action, index) in filterAtions(data)"
            :key="index"
            @click.native.stop="action.handler(data, type)"
          >
            <i :class="action.icon"></i>{{ action.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-tree>
</template>
<script>
import { Button, Tree, Dropdown, DropdownItem, DropdownMenu } from 'element-ui'

import { CATEGORY_TYPE } from '@/utils/enum'

export default {
  name: 'ClassifyTree',
  components: {
    [Button.name]: Button,
    [Tree.name]: Tree,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    actions: {
      type: Array,
      default() {
        return []
      }
    },
    type: {
      type: String,
      default() {
        return CATEGORY_TYPE.ARTICLE
      }
    },
    activeId: {
      type: [String, Number],
      default() {
        return 0
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    randomNumber() {
      return (
        '' +
        Math.floor(Math.random() * 10) +
        Math.floor(Math.random() * 10) +
        Math.floor(Math.random() * 10) +
        Math.floor(Math.random() * 10)
      )
    }
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      let category = this.getCategoryById(this.activeId, this.data)
      if (!category) {
        category = this.data[0]
      }
      this.$refs.tree.setCurrentKey(this.$refs.tree.store.getNode(category))
    })
  },
  methods: {
    handleTreeClick(data) {
      if (data.id === 0 && this.activeId !== 0) return
      this.$emit('handleTreeClick', data)
    },
    filterAtions(data) {
      let actions = this.actions.filter(item => {
        let condition1 = false
        let condition2 = false
        for (let property in item.enabled) {
          if (item.enabled[property].is && item.enabled[property].is.length) {
            item.enabled[property].is.map((val, index) => {
              if (index === 0) {
                condition1 = data[property] === val
              } else {
                condition1 = condition1 || data[property] === val
              }
            })
          } else {
            condition1 = true
          }
          if (item.enabled[property].not && item.enabled[property].not.length) {
            item.enabled[property].not.map((val, index) => {
              if (index === 0) {
                condition2 = data[property] !== val
              } else {
                condition2 = condition2 || data[property] !== val
              }
            })
          } else {
            condition2 = true
          }
        }
        if (condition1 && condition2) {
          return item
        }
      })
      return actions
    },
    getCategoryById(id, dataArr) {
      let category = null
      for (let i in dataArr) {
        if (dataArr[i].id === id) {
          return dataArr[i]
        } else {
          if (dataArr[i].children && dataArr[i].children.length) {
            category = this.getCategoryById(id, dataArr[i].children)
            if (category) {
              return category
            }
          }
        }
      }
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-classfiy-tree) {
  @include e(node) {
    display: flex;
    justify-content: space-between;
    flex: 1;
    padding-right: 20px;
    height: 44px;
    line-height: 44px;
    align-items: center;
    min-width: 0;
    @include m(active) {
      background: #dfeaff;
    }
  }
  @include e(node-label) {
    font-size: $--size-base;
    color: $--color-grey-8;
    flex: 1;
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  @include e(node-handler) {
    flex-shrink: 0;
    margin-left: 2px;
    width: fit-content;
  }
}
</style>
